<app-confirm-dialog
  data-testid="om-create-dialog"
  [visible]="true"
  [icon]="recordOnly() ? 'radio_button_checked' : 'add'"
  confirmColor="primary"
  [wide]="!recordOnly()"
  [title]="title() | translate"
  [message]="message() | translate: { name: library()?.name }"
  [confirmLabel]="submitLabel() | translate"
  [cancelLabel]="'objectMappings.create.cancel' | translate"
  [showCancel]="recording() || way() !== 'tox'"
  [busy]="saving()"
  [confirmDisabled]="!canSubmit()"
  (confirmed)="submit()"
  (cancelled)="cancel()"
>
  <form data-testid="om-create-form" class="omc-form" (submit)="$event.preventDefault(); submit()">
    @if (!recordOnly()) {
      <mat-form-field appearance="fill" floatLabel="always" class="omc-field tc-field tc-field--uppercase-label">
        <mat-label>{{ 'objectMappings.create.name' | translate }}</mat-label>
        <input
          #nameInput
          matInput
          required
          data-testid="om-create-name"
          autocomplete="off"
          [value]="name()"
          [disabled]="locked()"
          [attr.maxlength]="fieldLengths.NAME_MAX"
          [attr.aria-describedby]="showInvalid() ? 'om-create-invalid' : null"
          (input)="onNameInput($event)"
        />
        <mat-hint>{{ 'objectMappings.create.nameHint' | translate }}</mat-hint>
      </mat-form-field>
      @if (showInvalid()) {
        <p id="om-create-invalid" class="omc-hint omc-hint--error" data-testid="om-create-invalid">
          {{ 'objectMappings.create.invalidName' | translate }}
        </p>
      }

      <div class="omc-ways" role="radiogroup" [attr.aria-label]="'objectMappings.create.ways.legend' | translate">
        @for (option of ways; track option.id) {
          <label class="omc-way" [class.omc-way--active]="way() === option.id" [class.omc-way--disabled]="locked()">
            <span class="omc-way__icon" aria-hidden="true">
              <mat-icon>{{ option.icon }}</mat-icon>
            </span>
            <span class="omc-way__text">
              <span class="omc-way__label">{{ 'objectMappings.create.ways.' + option.id + '.label' | translate }}</span>
              <span class="omc-way__desc">{{ 'objectMappings.create.ways.' + option.id + '.desc' | translate }}</span>
            </span>
            <input
              type="radio"
              class="omc-way__radio"
              name="om-create-way"
              [attr.data-testid]="'om-create-way-' + option.id"
              [value]="option.id"
              [checked]="way() === option.id"
              [disabled]="locked()"
              (change)="chooseWay(option.id)"
            />
          </label>
        }
      </div>
    }

    @if (recording()) {
      <div class="omc-record">
        <app-runner-target-select
          data-testid="om-create-runner"
          [recordingProjectId]="projectId()"
          (targetChange)="target.set($event)"
          (connect)="cancel()"
        />
        <p class="omc-hint">{{ 'objectMappings.record.runnerHint' | translate }}</p>
        <mat-form-field appearance="fill" floatLabel="always" class="omc-field tc-field tc-field--uppercase-label">
          <mat-label>{{ 'objectMappings.record.startUrl' | translate }}</mat-label>
          <input
            #urlInput
            matInput
            required
            type="url"
            data-testid="om-create-url"
            autocomplete="url"
            [placeholder]="'objectMappings.record.startUrlPlaceholder' | translate"
            [value]="startUrl()"
            [attr.maxlength]="fieldLengths.URL_MAX"
            [attr.aria-describedby]="showUrlInvalid() ? 'om-create-url-invalid' : null"
            (input)="onUrlInput($event)"
          />
        </mat-form-field>
        @if (showUrlInvalid()) {
          <p id="om-create-url-invalid" class="omc-hint omc-hint--error" data-testid="om-create-url-invalid">
            {{ 'objectMappings.record.invalidUrl' | translate }}
          </p>
        }
      </div>
    } @else if (way() === 'tox') {
      <p class="omc-notice" data-testid="om-create-tox-hint">
        <mat-icon aria-hidden="true">info</mat-icon>
        <span>
          {{ 'objectMappings.create.ways.tox.hint' | translate }}
          @if (guideUrl) {
            <a [href]="guideUrl" target="_blank" rel="noopener">
              {{ 'objectMappings.create.ways.tox.guide' | translate }}
            </a>
          }
        </span>
      </p>
    }
  </form>

  @if (error(); as message) {
    <div class="omc-error" role="alert" data-testid="om-create-error">
      <p class="omc-hint omc-hint--error">
        {{ message }}
        @if (activeJobId(); as jobId) {
          <a
            data-testid="om-create-to-recording"
            [routerLink]="['/projects', projectId(), 'object-mappings', mapping()?.id, 'recording', jobId]"
          >
            {{ 'objectMappings.record.toRecording' | translate }}
          </a>
        }
      </p>
      @if (createdLibrary() && !recordOnly()) {
        <button mat-stroked-button type="button" data-testid="om-create-to-library" (click)="toLibrary()">
          {{ 'objectMappings.record.toLibrary' | translate }}
        </button>
      }
    </div>
  }
</app-confirm-dialog>
